import type { components } from '@customerio/hydra-ui-api';

/**
 * A workspace push app (mobile app registration). Only `id` + `name` are read —
 * the delivery detail resolves a push delivery's `app_id` to its app name (Ember
 * `push.loadApps()` + `delivery.appName`).
 */
export type PushApp = Pick<components['schemas']['services_ui_api_apps_appModel'], 'id' | 'name'>;

// The active read sits under the `['workspace', id, …]` subtree so a workspace
// switch's `removeQueries({ queryKey: ['workspace', prevId] })` evicts it. The
// no-workspace sentinel sits outside that namespace and never receives data (its
// query uses `skipToken`), so there is nothing to evict there.
export const appKeys = {
  list: (workspaceId: number) => ['workspace', workspaceId, 'app', 'list'] as const,
  noWorkspace: () => ['app', 'no-workspace'] as const,
};
